<template>
    <component :is="layout">
        <modal-window
            @submit="closeModal"
            @cancel="closeModal"
            :width-size="60"
            :height-size="80"
            :submit-btn="{show:false, label:'Закрыть'}"
            :cancel-btn="{show:false, label:'Нет'}"
            :show-cancel-icon="true"
            v-if="modalIsShow">
            <network-graph v-if="modalIsGraph" :data="graphData" @render-is-ready="graphIsReady=true"/>
            <task-details v-if="modalIsTaskDetails" :task="detailedTask"/>
        </modal-window>
        <task-list-wrapper
            v-for="section in sectionsToShow"
            :key="section.key"
            :header="section.header"
            :is-expanded="sectionIsExpanded[section.key]"
            :tasks="filterTasksByStates(section.taskFilters)"
            :output-limit-value="section.outputLimitValue"
            :show-only-when-expanded="section.showOnlyWhenExpanded"
            @toggled="handleSectionToggled(section.key)"
            @click-on-show-graph-icon="openModalWindowWithGraph"
            @click-on-show-detailed-task-info-icon="openModalWindowWithTaskDetails"
        />
        <template v-slot:help-block>
            <h3>Добро пожаловать на платформу</h3>
            <div id="divScope">
                <iframe src="https://www.youtube.com/embed/hvLHj8AEAV4"
                        width="100%" height="315" frameborder="0" allowfullscreen></iframe>
                <div>
                    Добро пожаловать на платформу по работе с данными социальных сетей! Этот сервис разработан в рамках
                    <a class='link' href='https://opendata.university'>Университетского консорциума исследователей больших данных</a>.
                    Здесь Вы сможете выгружать и анализировать данные таких популярных платформ, как: Вконтакте, Одноклассники
                    Фейсбук, Твиттер, Инстаграм и других. Эти данные Вы сможете использовать в ваших исследовательских проектах
                    и при написании научных статей. Начните работу с платформой с просмотра обучающего видео выше. По всем
                    возникающим вопросам пишите в тех. поддержку <a @click.prevent='$store.commit("toggleSidebarState")' class='link' >support@opendata.university</a>
                </div>
            </div>
        </template>
    </component>
</template>

<script>
import SideBar from '../components/SideBar'
import PageContent from '../components/PageContent'
import TaskListWrapper from '../components/task_list/TaskListWrapper'
import ModalWindow from "../components/ModalWindow";
import NetworkGraph from "../components/NetworkGraph";
import TaskDetails from "../components/task_list/TaskDetails";

export default {
    name: 'Home',
    components: {
      SideBar,
      PageContent,
      TaskListWrapper,
      ModalWindow,
      NetworkGraph,
      TaskDetails,
    },
    data() {
      return {
        layout: 'default-layout',
        sections: [
          {
            key: 'active',
            header: 'Задачи в работе',
            taskFilters: ['active', 'pending'],
            outputLimitValue: 3
          },
          {
            key: 'finished',
            header: 'Выполненные задачи',
            taskFilters: ['finished', 'error'],
            outputLimitValue: 4
          },
          // {
          //   key: 'archived',
          //   header: 'Архив',
          //   showOnlyWhenExpanded: true,
          //   taskFilters: ['archived']
          // }
        ],
        sectionIsHidden: {
          active: false,
          finished: false,
          error: false,
          archived: false
        },
        sectionIsExpanded: {
          active: false,
          finished: false,
          error: false,
          archived: false
        },
        taskFetchInterval: null,
        modalIsShow: false,
        modalIsGraph: false,
        graphIsReady: false,
        graphData: {},
        modalIsTaskDetails: false,
        detailedTask: {},
      }
    },
    computed: {
      taskStates() {
        return this.$store.state.taskStates
      },
      sectionsToShow() {
        return this.sections.filter(section => !this.sectionIsHidden[section.key])
      }
    },
    methods: {
      handleSectionToggled(section) {
        if (this.sectionIsExpanded[section]) {
          this.restoreSections()
        } else {
          this.expandSection(section)
        }
      },
      restoreSections() {
        for (const sectionKey in this.sectionIsHidden) {
          this.sectionIsHidden[sectionKey] = false
          this.sectionIsExpanded[sectionKey] = false
        }
      },
      expandSection(state) {
        this.sectionIsExpanded[state] = true

        for (const otherState in this.sectionIsHidden) {
          if (otherState !== state) {
            this.sectionIsHidden[otherState] = true
          }
        }
      },
      filterTasksByStates(taskStates) {
        const result = []
        for (const taskState of taskStates) {
            const filtered = this.$store.getters.filterTasksByState[this.taskStates[taskState]]
            filtered.forEach(el => result.push(el))
        }
        return result
      },
      closeModal() {
        setTimeout(() => {
          this.modalIsShow = false
          this.modalIsTaskDetails = false
          this.modalIsGraph = false
        }, 500)
        this.graphIsReady=false
      },
      openModalWindowWithGraph(payload) {
        this.modalIsShow=true
        this.modalIsGraph = true
        this.modalIsTaskDetails = false
        this.convertDataToGraph(payload)
      },
      openModalWindowWithTaskDetails(task) {
        this.modalIsShow = true
        this.modalIsGraph = false
        this.modalIsTaskDetails = true
        this.detailedTask = task
      },
      convertDataToGraph(data) {
        data = JSON.parse(data);
        const nodes = data.nodes.map( node => {
          return {id:node.name, label:node.name}
        });
        const edges = data.edges.map( edge => {
          return {"from": edge.src,
            "to": edge.dest,
            "arrows":
              {"to":{"enabled":true,"type":"arrow"}}}
        });
        this.graphData = {nodes: nodes, edges: edges};
      }
    },
    async created() {
      await this.$store.dispatch('fetchTasks')
      this.taskFetchInterval = window.setInterval(() => this.$store.dispatch('fetchTasks'), 5000)
    },
    beforeRouteLeave(to, from, next) {
        window.clearInterval(this.taskFetchInterval)
        next()
    }
}
</script>

<style lang="sass" scoped>
</style>
